export { default as actions } from "./actions";
export { default as consts } from "./constants";
export { default as reducer } from "./reducer";
export { default as state } from "./state";



// WEBPACK FOOTER //
// ./src/redux/modules/localSettings/index.ts